import { format, makeApiCall } from "@swiggy-private/js-utils";

// context
import { ITableConfig } from "@swiggy-private/portal-dineout-context";
import { API_ENDPOINTS, GANDALF_API_HOST } from "../constants/api";
import { API_DEFAULT_HEADERS, customApiCall } from "../utils/api";
import { ICollectionDataInfo } from "../utils/types";

export const fetchCollectionData = async (
    params: ITableConfig & { collectionId: string; tags?: string },
    _makeApiCall: typeof makeApiCall,
) => {
    const { collectionId, restaurantId, tags } = params || {};
    const endpoint = format(API_ENDPOINTS.COLLECTIONS_PL_API, collectionId);

    const response = await customApiCall<ICollectionDataInfo>({
        _makeApiCall: _makeApiCall,
        apiHost: GANDALF_API_HOST,
        apiEndpoint: endpoint,
        opts: {
            searchParams: {
                restaurant_id: restaurantId,
                lat: API_DEFAULT_HEADERS.lat,
                lng: API_DEFAULT_HEADERS.lng,
            },
            method: "POST",
            bodyParams: {
                businessLine: "BUSINESS_LINE_DINEOUT",
                collection_identifier: collectionId,
                metaMap: {
                    itemtags: tags,
                    restaurant_id: restaurantId,
                },
            },
        },
    });

    return response;
};
